export const COUNTRY_CODES = [
    { value: '55',  label: '+55 (Brasil)' },
    { value: '1',   label: '+1 (EUA/Canadá)' },
    { value: '44',  label: '+44 (Reino Unido)' },
    { value: '33',  label: '+33 (França)' },
    { value: '49',  label: '+49 (Alemanha)' },
    { value: '34',  label: '+34 (Espanha)' },
    { value: '39',  label: '+39 (Itália)' },
    { value: '61',  label: '+61 (Austrália)' },
    { value: '81',  label: '+81 (Japão)' },
    { value: '86',  label: '+86 (China)' },
    { value: '91',  label: '+91 (Índia)' },
    { value: '7',   label: '+7 (Rússia)' },
    { value: '27',  label: '+27 (África do Sul)' },
    { value: '52',  label: '+52 (México)' },
    { value: '54',  label: '+54 (Argentina)' },
    { value: '31',  label: '+31 (Países Baixos)' },
    { value: '32',  label: '+32 (Bélgica)' },
    { value: '41',  label: '+41 (Suíça)' },
    { value: '46',  label: '+46 (Suécia)' },
    { value: '47',  label: '+47 (Noruega)' },
    { value: '45',  label: '+45 (Dinamarca)' },
    { value: '358', label: '+358 (Finlândia)' },
    { value: '351', label: '+351 (Portugal)' },
    { value: '353', label: '+353 (Irlanda)' },
    { value: '64',  label: '+64 (Nova Zelândia)' },
    { value: '65',  label: '+65 (Singapura)' },
    { value: '60',  label: '+60 (Malásia)' },
    { value: '56',  label: '+56 (Chile)' },
    { value: '57',  label: '+57 (Colômbia)' },
    { value: '48',  label: '+48 (Polônia)' },
    { value: '90',  label: '+90 (Turquia)' },
    { value: '82',  label: '+82 (Coreia do Sul)' },
  ];
  